import * as types from './actionTypes';

// Mode
export const fetchTimesheetMode = (unit_id) => ({
  type: types.FETCH_TIMESHEET_MODE_REQUEST,
  payload:{unit_id},
});

// Project
export const fetchTimesheetProject = (payload) => ({
  type: types.FETCH_TIMESHEET_PROJECT_REQUEST,
  payload,
});

// Module
export const fetchTimesheetModule = (payload) => ({
  type: types.FETCH_TIMESHEET_MODULE_REQUEST,
  payload,
});

// Task
export const fetchTimesheetTask = (payload) => ({
  type: types.FETCH_TIMESHEET_TASK_REQUEST,
  payload,
});

// Task Type
export const fetchTimesheetTaskType = (payload) => ({
  type: types.FETCH_TIMESHEET_TASKTYPE_REQUEST,
  payload,
});

// Non-Project > Task Type
export const fetchTimesheetNonProjectTaskType = (payload) => ({
  type: types.FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_REQUEST,
  payload,
});

// List
export const fetchTimesheetList = (payload) => ({
  type: types.FETCH_TIMESHEET_LIST_REQUEST,
  payload,
});

// Month wise details
export const fetchTimesheetMonthDetails = (payload) => ({
  type: types.FETCH_TIMESHEET_MONTH_DETAILS_REQUEST,
  payload,
});

// Save Timesheet
export const saveTimesheetApplyDetails = (payload) => ({
  type: types.SAVE_TIMESHEET_DETAILS_REQUEST,
  payload,
});

// Change Task Status
export const changeTimesheetTaskStatus = (payload) => ({
  type: types.CHANGE_TIMESHEET_TASK_STATUS_REQUEST,
  payload,
});

export const fetchTimesheetClient = (unit_id,create_by) => ({
  type: types.FETCH_TIMESHEET_CLIENT_REQUEST,
  payload:{unit_id,create_by},
});
